<template>
    <div>
      <div class="laypanel" style="margin: 40px;">
        <div class="querypanel">
          <el-row>
            <el-form ref="form"  label-width="120px" label-position="left">
              <el-col :span="24">
                <el-form-item label="广告名称:">
                  <el-input v-model="ggname" placeholder="请输入广告名称"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="日期:">
                  <el-date-picker
                    v-model="byorderdate"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="回调:">
                  <el-switch
                    v-model="hd"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-text="下行量"
                    inactive-text="总量">
                  </el-switch>
                </el-form-item>
              </el-col>
            </el-form>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-button style="margin-top: 10px; margin-left: 10px;" @click="queryhdtj">开始统计</el-button>
              <el-button style="margin-top: 10px; margin-left: 10px;" @click="querynewhdtj">开始新统计</el-button>
              <el-button style="margin-top: 10px; margin-left: 10px;" @click="dctj">导出统计</el-button>
            </el-col>
          </el-row>
        </div>

        <el-row style="margin-top: 20px;">
          <el-col :span="24">
            <el-table
              stripe
              v-loading="clickloading"
              :data="hddata"
              ref="multipleTable">
              <el-table-column
                prop="APP_NAME"
                label="广告">
              </el-table-column>
              <el-table-column
                prop="NAME"
                label="渠道">
              </el-table-column>
              <el-table-column
                prop="GGCOUNT"
                label="数量">
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </div>
    </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import XLSX from 'xlsx'
  Vue.prototype.$http = axios
  var that
  export default {
    name: 'TJHD',
    data () {
      return {
        hd: true,
        clickcount: '',
        gglist: [],
        gginfo: '',
        qdlist: [],
        qdinfo: '',
        byorderdate: '',
        clickloading: false,
        dataway: true,
        hddata: [],
        ggname: ''
      }
    },
    mounted: function () {
      that = this
      that.$options.methods.querygg()
      that.$options.methods.queryqd()
    },
    methods: {
      dctj () {
        var xlsdata = []
        for (var i = 0; i< that.hddata.length; i++) {
          var tmpdata = that.hddata[i]
          var xlstmp = {
            '广告名':tmpdata.APP_NAME,
            '渠道': tmpdata.NAME,
            '数量': tmpdata.GGCOUNT
          }
          xlsdata.push(xlstmp)
        }
        window.console.log('订单导出信息')
        window.console.log(xlsdata)
        // 表名
        var ws = XLSX.utils.json_to_sheet(xlsdata);
        /* get binary string as output */
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, '回调统计');
        /* 生成xlsx文件 */
        XLSX.writeFile(wb, '回调统计.xlsx');
      },
      querygg () {
        that.$http({
          url: 'http://api.jiyuewuxian.cn/getads',
          method: 'get',
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            if (res.status === 200) {
              that.gglist = res.data
            } else {
              that.gglist = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      queryqd () {
        that.$http({
          url: 'http://api.jiyuewuxian.cn/getchannels',
          method: 'get',
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            if (res.status === 200) {
              that.qdlist = res.data
            } else {
              that.qdlist = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      queryhdtj () {
        var hdinfo = '1'
        if (this.hd) {
          hdinfo = '1'
        } else {
          hdinfo = '2'
        }
        var startdate = ''
        if (that.byorderdate[0] !== '') {
          startdate = that.byorderdate[0]
        }
        var enddate = ''
        if (that.byorderdate[1] !== '') {
          enddate = that.byorderdate[1]
        }
        var qdata = {
          ggname: this.ggname,
          startdate: startdate,
          enddate: enddate,
          flag: hdinfo
        }
        that.clickloading = true
        that.$http({
          url: 'http://api.jiyuewuxian.cn/getqdjh',
          method: 'post',
          data: qdata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            that.clickloading = false
            if (res.status === 200) {
              that.hddata = res.data
            } else {
              that.hddata = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      querynewhdtj () {
        var hdinfo = '1'
        if (this.hd) {
          hdinfo = '1'
        } else {
          hdinfo = '2'
        }
        var startdate = ''
        if (that.byorderdate[0] !== '') {
          startdate = that.byorderdate[0]
        }
        var enddate = ''
        if (that.byorderdate[1] !== '') {
          enddate = that.byorderdate[1]
        }
        var qdata = {
          ggname: this.ggname,
          startdate: startdate,
          enddate: enddate,
          flag: hdinfo
        }
        that.clickloading = true
        that.$http({
          url: 'http://api.jiyuewuxian.cn/getnewqdjh',
          method: 'post',
          data: qdata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            that.clickloading = false
            if (res.status === 200) {
              that.hddata = res.data
            } else {
              that.hddata = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/gg/TJHD.vue